import { currentVersion } from "./version";

export const PREFIX_RETX_PATH = `${process.env.API_PREFIX_RETX}/${currentVersion}`;

export const PREFIX_IDENTITY_PATH = `${process.env.API_PREFIX_IDENTITY}/${currentVersion}`;

export const PREFIX_TOPUP_PATH = `${process.env.API_PREFIX_TOPUP}/${currentVersion}`;

export const PREFIX_SCM_PATH = `${process.env.API_PREFIX_SCM}/${currentVersion}`;

export const PREFIX_NOTIFICATION_PATH = `${process.env.API_PREFIX_NOTIFICATION}/${currentVersion}`;
export const OTP_PATH = `${PREFIX_IDENTITY_PATH}/otp`;
export const AUTH_PATH = `${PREFIX_IDENTITY_PATH}/system_users`;
export const USER_PATH = `${PREFIX_IDENTITY_PATH}/users`;
